// Full-document render of the tempurpedic TempurLoveRootPage: PageSkeleton
// (the React document shell) wrapping the hub header (love_root is the page
// itself; the legacy partial's {% if love_root %} gate is always-true here)
// and the shared TempurLove grid body, whose props arrive flattened on this
// template. Both grid routes (default and c/<category>/) render this same
// document; neither island host div carried CSS/JS anchors, so the bodies
// render bare.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { TempurLoveHeader } from "../components/TempurLoveHeader";
import { Template as TempurLoveGrid } from "./TempurLoveGridTemplate";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton).
type IProps = templates.TempurLoveRootPageTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <TempurLoveHeader love_root={props.love_root} />
            <TempurLoveGrid
                filter_by={props.filter_by}
                base_api_url={props.base_api_url}
                initial_grid_data={props.initial_grid_data}
                initial_next_url={props.initial_next_url}
                breadcrumb_items={props.breadcrumb_items}
                root_url={props.root_url}
            />
        </PageSkeleton>
    );
};
